import React from 'react';
import { Chip, alpha } from '@mui/material';
import { SEARCE_COLORS } from '../../theme';

interface TypeChipProps {
  type: string;
}

export const TypeChip: React.FC<TypeChipProps> = ({ type }) => {
  const getTypeStyles = (type: string) => {
    const typeLower = type.toLowerCase();
    
    // Customer Response Status styles
    if (typeLower.includes('received')) {
      return { bgColor: alpha(SEARCE_COLORS.success, 0.15), color: SEARCE_COLORS.success };
    }
    if (typeLower.includes('awaiting')) {
      return { bgColor: alpha(SEARCE_COLORS.warning, 0.15), color: SEARCE_COLORS.warning };
    }
    
    // Email Status styles
    if (typeLower === 'success') {
      return { bgColor: alpha(SEARCE_COLORS.success, 0.15), color: SEARCE_COLORS.success };
    }
    if (typeLower === 'sent') {
      return { bgColor: alpha(SEARCE_COLORS.success, 0.15), color: SEARCE_COLORS.success };
    }
    if (typeLower === 'failed') {
      return { bgColor: alpha(SEARCE_COLORS.error, 0.15), color: SEARCE_COLORS.error };
    }
    if (typeLower.includes('not sent')) {
        return { bgColor: alpha(SEARCE_COLORS.gray_400, 0.2), color: SEARCE_COLORS.textSecondary };
    }
    
    // Zoho Status styles
    if (typeLower === 'n/a' || typeLower === 'na') {
      return { bgColor: alpha(SEARCE_COLORS.gray_400, 0.2), color: SEARCE_COLORS.textSecondary };
    }
    if (typeLower.includes('failed issue creation')) {
      return { bgColor: alpha(SEARCE_COLORS.error, 0.15), color: SEARCE_COLORS.error };
    }
    if (typeLower === 'open') {
      return { bgColor: alpha(SEARCE_COLORS.warning, 0.15), color: SEARCE_COLORS.warning };
    }
    if (typeLower.includes('in progress')) {
      return { bgColor: alpha(SEARCE_COLORS.primary, 0.15), color: SEARCE_COLORS.primary };
    }
    if (typeLower === 'closed') {
      return { bgColor: alpha(SEARCE_COLORS.success, 0.15), color: SEARCE_COLORS.success };
    }
    if (typeLower.includes('to be tested')) {
      return { bgColor: alpha(SEARCE_COLORS.secondary, 0.15), color: SEARCE_COLORS.secondary };
    }
    
    // General Status styles
    if (typeLower.includes('positive') || typeLower.includes('resolved') || typeLower.includes('acknowledged') || typeLower.includes('responded') || typeLower === 'created') {
      return { bgColor: alpha(SEARCE_COLORS.success, 0.15), color: SEARCE_COLORS.success };
    }
    if (typeLower.includes('negative') || typeLower.includes('open') || typeLower.includes('failed')) {
      return { bgColor: alpha(SEARCE_COLORS.error, 0.15), color: SEARCE_COLORS.error };
    }
    if (typeLower.includes('pending') || typeLower.includes('awaiting')) {
      return { bgColor: alpha(SEARCE_COLORS.warning, 0.15), color: SEARCE_COLORS.warning };
    }
    if (typeLower.includes('sent')) {
      return { bgColor: alpha(SEARCE_COLORS.primary, 0.15), color: SEARCE_COLORS.primary };
    }
    
    // Overall Satisfaction styles - handle all 5 types with distinct colors
    // Check in order from most specific to least specific
    if (typeLower.includes('highly dissatisfied')) {
      return { bgColor: alpha(SEARCE_COLORS.error, 0.2), color: SEARCE_COLORS.error };
    }
    if (typeLower.includes('highly satisfied')) {
      return { bgColor: alpha(SEARCE_COLORS.success, 0.2), color: SEARCE_COLORS.success };
    }
    if (typeLower.includes('dissatisfied') && !typeLower.includes('highly')) {
      return { bgColor: alpha('#ff9800', 0.2), color: '#ff9800' }; // Orange for dissatisfied
    }
    if (typeLower.includes('satisfied') && !typeLower.includes('highly')) {
      return { bgColor: alpha(SEARCE_COLORS.success, 0.15), color: SEARCE_COLORS.success };
    }
    if (typeLower === 'neutral') {
      return { bgColor: alpha(SEARCE_COLORS.gray_400, 0.2), color: SEARCE_COLORS.textSecondary };
    }
    
    // Type/Level styles
    if (typeLower === 'project') {
      return { bgColor: alpha(SEARCE_COLORS.primary, 0.15), color: SEARCE_COLORS.primary };
    }
    if (typeLower === 'individual') {
      return { bgColor: alpha(SEARCE_COLORS.secondary, 0.15), color: SEARCE_COLORS.secondary };
    }
    
    // Default
    return { bgColor: alpha(SEARCE_COLORS.primary, 0.1), color: SEARCE_COLORS.primary };
  };

  const styles = getTypeStyles(type);

  return (
    <Chip
      label={type}
      size="small"
      sx={{
        backgroundColor: styles.bgColor,
        color: styles.color,
        fontWeight: 500,
        fontSize: '0.75rem',
        height: 24,
        borderRadius: '12px',
        '& .MuiChip-label': { px: 1.5 },
      }}
    />
  );
};
